/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { CustQuotOtpDto } from '../model/custQuotOtpDto';
import { InsertApplicationResponseDto } from '../model/insertApplicationResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CustQuotOtpControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * checkOtp
     * 
     * @param custQuotOtpDto custQuotOtpDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkOtpUsingPOST(custQuotOtpDto: CustQuotOtpDto, observe?: 'body', reportProgress?: boolean): Observable<InsertApplicationResponseDto>;
    public checkOtpUsingPOST(custQuotOtpDto: CustQuotOtpDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InsertApplicationResponseDto>>;
    public checkOtpUsingPOST(custQuotOtpDto: CustQuotOtpDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InsertApplicationResponseDto>>;
    public checkOtpUsingPOST(custQuotOtpDto: CustQuotOtpDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (custQuotOtpDto === null || custQuotOtpDto === undefined) {
            throw new Error('Required parameter custQuotOtpDto was null or undefined when calling checkOtpUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<InsertApplicationResponseDto>(`${this.basePath}/applicant/consent/check`,
            custQuotOtpDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * genOtp
     * 
     * @param custQuotOtpDto custQuotOtpDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public genOtpUsingPOST(custQuotOtpDto: CustQuotOtpDto, observe?: 'body', reportProgress?: boolean): Observable<CustQuotOtpDto>;
    public genOtpUsingPOST(custQuotOtpDto: CustQuotOtpDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustQuotOtpDto>>;
    public genOtpUsingPOST(custQuotOtpDto: CustQuotOtpDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustQuotOtpDto>>;
    public genOtpUsingPOST(custQuotOtpDto: CustQuotOtpDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (custQuotOtpDto === null || custQuotOtpDto === undefined) {
            throw new Error('Required parameter custQuotOtpDto was null or undefined when calling genOtpUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CustQuotOtpDto>(`${this.basePath}/applicant/consent`,
            custQuotOtpDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * resendOtp
     * 
     * @param custQuotOtpDto custQuotOtpDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resendOtpUsingPOST(custQuotOtpDto: CustQuotOtpDto, observe?: 'body', reportProgress?: boolean): Observable<CustQuotOtpDto>;
    public resendOtpUsingPOST(custQuotOtpDto: CustQuotOtpDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustQuotOtpDto>>;
    public resendOtpUsingPOST(custQuotOtpDto: CustQuotOtpDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustQuotOtpDto>>;
    public resendOtpUsingPOST(custQuotOtpDto: CustQuotOtpDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (custQuotOtpDto === null || custQuotOtpDto === undefined) {
            throw new Error('Required parameter custQuotOtpDto was null or undefined when calling resendOtpUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CustQuotOtpDto>(`${this.basePath}/applicant/consent/resend`,
            custQuotOtpDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
